import type { StepLockStatus } from './StepLockControl';

/**
 * Derive the StepLockStatus from a locked boolean and conditionsMet boolean.
 */
export function deriveStepStatus(locked: boolean, conditionsMet: boolean): StepLockStatus {
  if (locked) return 'locked';
  if (conditionsMet) return 'ready';
  return 'open';
}
